import Service from "../Service";

const resource = "ExtCommercialContract/";

export default {
  pagination(filter, requestID) {
    return Service.post(resource + "pagination", filter, {
      params: { requestID: requestID },
    });
  },

  getById(id, requestID) {
    return Service.post(resource + "getById", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },

  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID: requestID },
    });
  },

  cancel(id, requestID) {
    return Service.post(resource + "cancel", id, {
      headers: { "Content-Type": "application/json" },
      params: { requestID: requestID },
    });
  },
};
